import styled from 'styled-components';
import { Color } from '../../../../common/view/color/color';

const Container = styled.div.withConfig({
  componentId: 'desktop-today_container',
  displayName: 'DesktopToday.Container',
})`
  &.collapsed {
    width: 72px;
  }

  &.not-collapsed {
    width: 400px;
  }

  height: 100%;

  background: ${Color.black2};
  border-right: 1px solid ${Color.black4};

  padding: 20px;
`;

export const DesktopTodayStyle = {
  Container,
};
